export default class KapcsoltTermekKartya {
    constructor() {
        this.initEvents();
    }

    initEvents() {
        $(document).on('click', '.kapcsolt-termek-btn', (e) => {
            e.preventDefault();
            const $btn = $(e.currentTarget);

            if ($btn.hasClass('is-added') || $btn.hasClass('is-loading')) {
                return false;
            }

            const termekId = $btn.data('termek_id');
            const kiszerelesType = $btn.data('kiszereles_type');

            if (!termekId) {
                return false;
            }

            $btn.addClass('is-loading');

            const postData = {
                termek_id: termekId,
                type_1: kiszerelesType,
                db_1: 1,
                sessdata: typeof shopSessData !== 'undefined' ? shopSessData : ''
            };

            const $cart = $('.webshop-button-d2');
            const $targetCart = ($cart.length && $cart.is(':visible'))
                ? $cart
                : $('#kosarlink1, #kosarlink2, .header .tools .shop, .webshop-button-d2').filter(':visible').first();

            if ($targetCart.length) {
                const $imgclone = $btn.clone()
                    .addClass('shrink')
                    .offset({ top: $btn.offset().top, left: $btn.offset().left })
                    .css({
                        'opacity': '0.5',
                        'position': 'absolute',
                        'overflow': 'hidden',
                        'z-index': '1000'
                    })
                    .appendTo($('body'));

                $imgclone.animate({
                    top: $targetCart.offset().top + 10,
                    left: $targetCart.offset().left + 30
                }, 500, 'swing', function () {
                    $(this).detach();
                    $('.webshop-button-d2').addClass('changed');
                });
            }

            $.post('/kosar/ad', postData, (res) => {
                $btn.removeClass('is-loading').addClass('is-added');

                if (res && res.kos && typeof res.kos.allproduct !== 'undefined') {
                    $('.webshop-button-d2 .cart-num, #kosarlink1 .amount, #kosarlink2 .amount, .header .tools .shop .amount').each(function () {
                        $(this).text(res.kos.allproduct);
                        if (+res.kos.allproduct > 9) {
                            $(this).addClass('wider');
                        }
                    });
                }

                if (typeof Kosar !== 'undefined' && typeof Kosar.saveKosarToBrowser === 'function') {
                    Kosar.saveKosarToBrowser();
                }

                setTimeout(() => {
                    $('.webshop-button-d2').removeClass('changed');

                    if (typeof Kosar !== 'undefined' && typeof Kosar.showSelectdialog === 'function') {
                        Kosar.showSelectdialog(postData);
                    }
                }, 1100);

                setTimeout(() => {
                    $btn.removeClass('is-added');
                }, 3000);
            }).fail(() => {
                $btn.removeClass('is-loading');
            });

            return false;
        });
    }
}
